<template>
  <div :class="$style.container">
    <language-tap-bar
      :language-code="language.code"
      :inverted-color="invertedColor"
      @click="handleClick"
    />

    <languages-list-modal
      v-model="isShownLanguagesList"
      :current-language="language"
    />
  </div>
</template>

<script>
import LanguageTapBar from 'organisms/localization/LanguageTapBar';
import LanguagesListModal from 'organisms/localization/LanguagesListModal';

export default {
  name: 'LocalizationController',
  components: {
    LanguageTapBar,
    LanguagesListModal,
  },
  props: {
    language: {
      type: Object,
      required: true,
    },
    invertedColor: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      isShownLanguagesList: false,
    };
  },
  methods: {
    handleClick() {
      this.isShownLanguagesList = true;
    },
  },
};
</script>

<style lang="sass" module>
  .container
    cursor: pointer
</style>
